<template>
  <div id="app">
    <div class="topBar-box">
      <TopBar :userName="userName"/>
    </div>
    <div class="app_container">
      <SideBar v-if="isShowSideBar" :menuTree="menuTree"/>
      <main class="content">
        <Breadcrumb v-if="isShowSideBar"/>
        <router-view/>
      </main>
    </div>
    <Login v-if="showLogin"/>
  </div>
</template>

<script>
import TopBar from './components/common/TopBar';
import SideBar from './components/common/SideBar';
import Breadcrumb from './components/common/Breadcrumb';
import Login from './components/common/Login';
import { getLocalStorage } from './utils/utils';
// import ResetPassword from './views/account//ResetPassword';
export default {
  name: 'App',
  data() {
    return {
      showLogin: true,
      userName: '',
      menuTree: [],
      isShowSideBar: false,
    };
  },
  components: {
    SideBar,
    TopBar,
    Breadcrumb,
    Login,
  },
  watch: {
    $route(to, from) {
      const element = document.getElementsByClassName('content');
      if (to.path.indexOf('/home') !== -1 || to.path === '/') {
        element[0].className = 'content home-main-content';
      } else {
        element[0].className = 'content';
      }
    },
  },
  created() {
    const userName = getLocalStorage('userName');
    if (userName) {
      this.showLogin = false;
      this.userName = userName;
      this.getMenu();
    }
  },
  mounted() {
    if (window.location.pathname.indexOf('/home') !== -1 || window.location.pathname === '/') {
      const element = document.getElementsByClassName('content');
      element[0].className = 'content home-main-content';
    }
    this.$bus.$on('showLogin', () => {
      this.showLogin = true;
    });
    this.$bus.$on('login', (userName) => {
      this.showLogin = false;
      this.userName = userName;
      this.getMenu();
    });
    this.$bus.$on('logout', () => {
      this.showLogin = true;
      this.userName = '';
    });
  },
  methods: {
    getMenu() {
      this.$http.get('/admin/getMenu').then((res) => {
        if (res.Code === this.$requestCode.RESPONSE_SUCCESS.code) {
          this.menuTree = res.Data.MenuTree;
          if (this.menuTree.length === 1 && this.menuTree[0].Code === 'AnalyseContainer' && /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
            this.isShowSideBar = false;
          } else {
            this.isShowSideBar = true;
          }
        } else {
          this.$requestStatus(res);
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import './assets/scss/common/common.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue